import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { UpdateTagMutationRequest, UpdateTagMutationResponse, UpdateTagPathParams } from "../types/UpdateTag";

/**
 * @link /api/ms-content-infoportal-backend/v1/admin/tags/:tagId
 */

export function useUpdateTag <TData = UpdateTagMutationResponse, TError = unknown, TVariables = UpdateTagMutationRequest>(tagId: UpdateTagPathParams["tagId"], options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, TVariables>,
          client?: Partial<Parameters<typeof client<TData, TError, TVariables>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, TVariables> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, TVariables>({
    mutationFn: (data) => {
      
      return client<TData, TError, TVariables>({
        method: "patch",
        url: `/api/ms-content-infoportal-backend/v1/admin/tags/${tagId}`,
        data,
        
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
